import { createSlice } from "@reduxjs/toolkit";
import { Loading, User, UserRepository } from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type UserState = {
  userInfo?: User;
  loading: Loading;
};

const initialState: UserState = {
  loading: "idle",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userLoading(state) {
      state.userInfo = undefined;
      state.loading = "pending";
    },
    userLoaded(state, { payload }) {
      state.userInfo = payload;
      state.loading = "succeeded";
    },
    userFailed(state) {
      state.loading = "failed";
    },
  },
});

export default userSlice.reducer;

const { userLoading, userFailed, userLoaded } = userSlice.actions;

export const loadUser = (): AppThunk => async (dispatch) => {
  dispatch(userLoading());
  const res = await ServiceLocater.get<UserRepository>(
    Services.UserRepository
  ).getInfo();
  res.fold(
    (l) => dispatch(userFailed()),
    (r) => dispatch(userLoaded(r))
  );
};
